import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-booking-details-excess-display',
  templateUrl: './booking-details-excess-display.component.html',
  styleUrls: ['./booking-details-excess-display.component.scss']
})
export class BookingDetailsExcessDisplayComponent implements OnInit {

  @Input()
  appCopy = null;

  @Input()
  selectedLanguage = null;
  
  @Input() excessBaggagePayment;

  @Input()
  receiptImg;

  @Input() currencySymbol;
  constructor() { }

  ngOnInit() {
  }

}
